import UtilsHelper from "../../helpers/Utils.helper";

export const getSpreadUsdc = async (userId, date) => {
   const path = `/api/v1/reports/spread_usdc/by_dates?initDate=${date.from}&endDate=${date.to}`
   return await UtilsHelper.sendRequest({
      userId,
      method: "GET",
      path,
   });
}